/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Computer_Science15Inputs */

const en_cv_extract_form_enum_computer_science15 = /** @type {(inputs: Cv_Extract_Form_Enum_Computer_Science15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer Science`)
};

const de_cv_extract_form_enum_computer_science15 = /** @type {(inputs: Cv_Extract_Form_Enum_Computer_Science15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informatik`)
};

/**
* | output |
* | --- |
* | "Computer Science" |
*
* @param {Cv_Extract_Form_Enum_Computer_Science15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_computer_science15 = /** @type {((inputs?: Cv_Extract_Form_Enum_Computer_Science15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Computer_Science15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_computer_science15(inputs)
	return en_cv_extract_form_enum_computer_science15(inputs)
});
export { cv_extract_form_enum_computer_science15 as "cv_extract_form_enum_COMPUTER_SCIENCE" }